import {defineElement} from "@acng/frontend-bounty/dom/custom.js";
import {CTX_SUBSCRIBE_TAGNAME} from "@acng/frontend-relativity/minify";
import {REGISTRY_ELEMENT} from "../model/resource.js";
import {lookup} from "./lookup.js";
import {forEachOfArray} from "@acng/frontend-bounty";
import {defineCompileElement} from "./compile.js";

/**
 * @template {HTMLElement & Record<string, any>} T
 * @param {import("../model/utility/feature").FeatureUtility} feature
 * @param {string} name
 * @param {import("../model/widget").WidgetConstructor<T>} Widget
 * @param {readonly import("@acng/frontend-relativity").Context<unknown>[]} [contexts]
 */
export function defineCustomWidget(feature, name, Widget, contexts) {
  const removeIfHidden = CommonElementDefinition(feature, Widget, contexts)(name);

  Widget.consumables?.forEach((ctx) => ctx.subscribeTagName(name));

  defineCompileElement(name, (element, promises) => {
    removeIfHidden(element);
    if (!element.parentNode) {
      return;
    }
    if (Widget.setup) {
      promises.push(Widget.setup());
    }
    if (Widget.template) {
      promises.push(
        lookup(feature[REGISTRY_ELEMENT], [name]).then((template) => {
          Widget[REGISTRY_ELEMENT] = template;
        })
      );
    }
  });
}

/**
 * @internal
 * @template {typeof HTMLElement} T
 * @param {import("../model/utility/feature").FeatureUtility} feature
 * @param {T} Constructor
 * @param {readonly import("@acng/frontend-relativity").Context<unknown>[]} [contexts]
 * @returns {(name: string) => (element: Element) => void}
 */
export const CommonElementDefinition = (feature, Constructor, contexts) => (name) => (
  defineElement(name, Constructor),
  forEachOfArray(contexts, (ctx) => ctx[CTX_SUBSCRIBE_TAGNAME](name)),
  (element) => {
    if (feature.isHidden) {
      element.remove();
    }
  }
);
